import { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import base64url from "base64url";
import { Auth } from '@janiscommerce/sdk'

import { authorizeEndpoint, oauthClientId, oauthRedirectPath, pkceVerifierCookieName } from '../constants';

const options = {
	client_id: oauthClientId,
	scope: 'openid profile',
	redirect_uri: `${window.location.origin}${oauthRedirectPath}`
};

const authClient = new Auth(options);

const useAuthorizeUrl = (shouldGenerate = true) => {

	const [, setCookie] = useCookies([pkceVerifierCookieName]);
	const [authorizeUrl, setAuthorizeUrl] = useState('');

	const { location } = window;

	useEffect(() => {

		if(!shouldGenerate) {
			return;
		}

		const {
			codeVerifier,
			codeChallenge,
			codeChallengeMethod
		} = authClient.generatePKCEChallenge();

		setAuthorizeUrl(authClient.getAuthorizeUrl({
			code_challenge: codeChallenge,
			code_challenge_method: codeChallengeMethod,
			state: base64url.encode(JSON.stringify({
				location: location.href.split(location.host)[1]
			}))
		}, authorizeEndpoint));

		setCookie(pkceVerifierCookieName, codeVerifier, { path: '/' });

	}, [location.host, location.href, setCookie, shouldGenerate]);

	return authorizeUrl;
};

export default useAuthorizeUrl;
